<template>
  <div>
    <v-container grid-list-xl fluid v-if="showDashboard">
      <v-layout row wrap>
        <v-flex xs10 offset-xs1>
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <h1>Update Daily Company Target</h1>
              </v-flex>
              <v-flex xs6>
                <v-text-field class="xs10" v-model="setting.companyTarget"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-btn class='ml-0' @click="updateCompanyTarget()">update</v-btn>
              </v-flex>
              <v-flex xs12>
                <h1>Update Monthly Target</h1>
              </v-flex>
              <v-flex xs12>
                <table width="100%" class="">
                  <thead>
                    <tr>
                      <th width="35%" class="text-xs-left">Name</th>
                      <th width="25%" class="text-xs-left">Email</th>
                      <th width="25%" class="text-xs-center">Monthly Target</th>
                      <th width="15%" class="text-xs-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user, index) in salesUsers" :key="index">
                      <td class="text-xs-left">{{user.firstName}}</td>
                      <td class="text-xs-left">{{user.email}}</td>
                      <td class="text-xs-left"><v-text-field class="xs10" v-model="user.position.target"></v-text-field></td>
                      <td class="text-xs-center"><v-btn small @click="updateTarget(user)">update</v-btn></td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
              <v-snackbar dark top v-model="snackbar" :timeout="3000">
                {{ popupText }}
                <v-btn dark flat @click="snackbar = false">Close</v-btn>
              </v-snackbar>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl fluid v-else>
      <v-layout row wrap>
        <v-flex xs10 offset-xs1 text-xs-center>
          <h1>Nothing to show</h1>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import UserService from '@/services/UserService.js'
import SettingService from '@/services/SettingService.js'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      snackbar: false,
      popupText: null,
      setting: {},
      salesUsers: [],
      showDashboard: false,
      loggedInUser: JSON.parse(atob(localStorage.getItem('user')))
    }
  },
  mounted () {
    if (this.loggedInUser.email === 'books@diyblinds.com.au') {
      this.showDashboard = false
    } else if (this.loggedInUser.position && ['manager'].includes(this.loggedInUser.position.role)) {
      this.showDashboard = true
      this.getSalesUsers()
      this.getSetting()
    }
  },
  validations: {
    currentPassword: { required },
    password: { required },
    confirmPassword: { required }
  },
  methods: {
    async getSetting () {
      const response = await SettingService.getSetting()
      this.setting = response.data.setting
    },
    async getSalesUsers () {
      const response = await UserService.getSalesUsers()
      this.salesUsers = response.data.users
    },
    async updateTarget (user) {
      const response = await UserService.updateUser(user)
      if (response.data.success === true) {
        this.snackbar = true
        this.popupText = 'Target updated.'
      }
    },
    async updateCompanyTarget () {
      const response = await SettingService.updateSetting(this.setting)
      if (response.data.success === true) {
        this.snackbar = true
        this.popupText = 'Company Target updated.'
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/salesUsers.vue